<template>
  <div class="voted">
    <div class="voted-inner">
      <img
        :src="require(`@images/hero/faces/${votedHero.hero_id}.png`)"
        class="hero-image"
        height="183"
        width="181"
      >
      <img
        :src="require(`@images/mypage/${$route.params.lang}/btn_voted.png`)"
        class="voted-text"
        :alt="$t('label001')"
      >
    </div>
    <p class="hero-name" v-html="votedHero.hero.name" />
  </div>
</template>

<script>
import localeMypage from '@locales/mypage'
export default {
  name: 'vote',
  $messages: localeMypage,
  props: {
    votedHero: {
      type: Object,
      required: true
    }
  }
}
</script>

<style lang="scss" scoped>
.voted {
  display: flex;
  flex-direction: column;
  align-items: center;
}
.voted-inner {
  position: relative;
  height: 183px;
  width: 181px;
}
.hero-image {
  position: absolute;
  top: 0;
  left: 0;
}
.voted-text {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
}
.hero-name {
  background-image: url(~@images/bg_hero-text.png);
  background-repeat: no-repeat;
  background-size: 100%  100%;
  background-position: center;
  text-align: center;
  padding: 5px 0;
  width: 100%;
}
</style>
